import React, { useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { joiResolver } from "@hookform/resolvers/joi";
import { rejectRequest } from "../../../../redux/actions/autoLombardActions";
import useIcons from "../../hooks/useIcons";
import { rejectionModalValidationScheme } from "../../ValidationSchemes";
import { DSelect } from "../../../../validation/HForm";
import { StatusButton, Modal } from "../../components";
import {rejectReasons} from "../../constants/constants";
import {iconNames} from "../../constants/icon-names";

const RejectionModal = ({
  isOpen,
  onClose,
  requestDetails,
  setRequestStatusValue,
}) => {
  const dispatch = useDispatch();
  const { getIcon } = useIcons();
  const { isRejected, error } = useSelector(({ autolombard }) => autolombard.currentRequest);
  const [options, setOptions] = useState(rejectReasons);
  const [selectedOption, setSelectedOption] = useState(null);
  const [inputValue, setInputValue] = useState("");
  const [rejectError, setRejectError] = useState("");

  const form = useForm({
    mode: "onChange",
    defaultValues: {
      decision: {},
    },
    resolver: joiResolver(rejectionModalValidationScheme),
  });

  const handleInputChange = (inputValue) => {
    setInputValue(inputValue);
    return inputValue;
  };

  const handleChange = (option) => {
    setSelectedOption(option);
    setInputValue(option ? option.label : "");
  };

  const handleBlur = () => {
    if (inputValue && !options.some((option) => option.label === inputValue)) {
      const newOption = { value: inputValue, label: inputValue };
      setOptions((prevOptions) => [...prevOptions, newOption]);
      setSelectedOption(newOption);
      form.setValue("decision", newOption, { shouldValidate: true });
    }
  };

  const onSubmit = (data) => {
    dispatch(
      rejectRequest({
        requestId: requestDetails.car_request.id,
        data: { decision: data.decision.label },
      })
    );
  };

  useEffect(() => {
    if (isRejected) {
      onClose();
    } else if (error) {
      setRejectError(error);
    }
  }, [isRejected, error]);

  return (
      <Modal isOpen={isOpen} onClose={onClose}>
        <div className="autolombard-modal-header">
          <p className="title">Укажите причину отклонения заявки</p>
          <button
              className="button-icontrigger modal-closetrigger"
              onClick={onClose}
          >
            <span className="icon">{getIcon(iconNames.CROSS)}</span>
          </button>
        </div>

        <FormProvider {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)} className="rejection-modal-form">
            <div className="rejection-modal-content">
              <div className="form-element gap-20">
                <div className="fullwidth">
                  <div className="form-element">
                    <label className="form-element-label" htmlFor="#">
                      Причина отклонения
                    </label>
                    <div className="form-element-data fullwidth selectReject">
                      <DSelect
                          name="decision"
                          placeholder="Выберите или введите"
                          options={options}
                          handleOptions={handleInputChange}
                          handleChangeContent={handleChange}
                          value={selectedOption}
                          onBlur={handleBlur}
                          inputValue={inputValue}
                          isSearchable
                          isClearable
                          menuPortalTarget={document.body}
                          styles={{
                            menuPortal: base => ({ ...base, zIndex: 9999 }),
                          }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="rejection-modal-footer">
              <StatusButton
                  label="Отклонить"
                  status="primary"
                  type="submit"
                  fullWidth
              />
            </div>
          </form>
        </FormProvider>
      </Modal>
  );
};

export default RejectionModal;
